import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import '../App.css';
import AppRoutes from './routes';
import favIcon from '../assets/fav_icon.png';

export default function App() {
  useEffect(() => {
    let iconLink = document.querySelector('link[rel="icon"]');
    if (!iconLink) {
      iconLink = document.createElement('link');
      iconLink.setAttribute('rel', 'icon');
      document.head.appendChild(iconLink);
    }
    iconLink.setAttribute('type', 'image/png');
    iconLink.setAttribute('href', favIcon);
  }, []);

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
